/**
 * The assistant WARM signal between the host shell and the chats pane.
 *
 * The pane connects on its first sight of the viewer (`usePaneVisibility`, `AssistantProvider`): room adopt, the
 * create call, the socket dial and the history read all start when the panel is first on screen -- which was the
 * click, so every first open paid 1.25-1.5s of socket upgrade with the composer disabled (dev, 2026-09-17). The host
 * now marks the pane WARM on intent (pointer or focus on the Assistant button) and mounts it hidden; the pane treats
 * warm as opened and connects, so by the click the socket is up.
 *
 * TWO HALVES, BECAUSE OF ORDER. The first intent mounts the pane in the render AFTER the mark, so an event alone is
 * missed; a window global alone would not wake a pane already mounted and waiting. The mark writes the global AND
 * dispatches the event; a pane reads the global on mount and listens for the event after.
 */

import { globalKey } from '@federa/const/global-namespace';
import { DOM_EVENTS } from '@federa/const/websocket-actions-dom';

const WARM_KEY = globalKey('AssistantWarm');

type WarmWindow = Pick<Window, 'addEventListener' | 'removeEventListener' | 'dispatchEvent'>;

/** Host side: latch the global and tell any mounted pane. */
export function markAssistantWarm(win: WarmWindow): void {
	Reflect.set(win, WARM_KEY, true);
	win.dispatchEvent(new Event(DOM_EVENTS.ASSISTANT_PANEL_WARM));
}

/** Pane side, on mount: was intent already seen before this pane existed? */
export function isAssistantWarm(win: WarmWindow): boolean {
	return Reflect.get(win, WARM_KEY) === true;
}

/** Pane side, while mounted: hear a later mark. Returns the teardown. */
export function onAssistantWarm(win: WarmWindow, listener: () => void): () => void {
	win.addEventListener(DOM_EVENTS.ASSISTANT_PANEL_WARM, listener);
	return () => win.removeEventListener(DOM_EVENTS.ASSISTANT_PANEL_WARM, listener);
}
